import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

type StartAssignmentBulkUpdateButtonProps = {
    readonly isLoading: boolean;
    readonly count: number;
    readonly onClick: () => void;
};

export const StartAssignmentBulkUpdateButton = ({
    isLoading,
    count,
    onClick,
}: StartAssignmentBulkUpdateButtonProps) => {
    const isDisabled = count === 0;

    return (
        <Button
            disabled={isDisabled}
            bsStyle={Button.PRIMARY}
            className={isLoading ? 'btn-loading disabled' : ''}
            iconName={isLoading ? '' : 'rioglyph-cards-add'}
            onClick={onClick}
        >
            <FormattedMessage id="outboundOrderBook.transportAssignments.toolbar.bulkUpdate" values={{ count }} />
        </Button>
    );
};
